import React, { useEffect } from "react";
import { isEmpty, path, pipe } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { getError, getProject } from "application/applicationReducer";
import SubmissionPanel from "../../submission/components/SubmissionPanel";
import ErrorPanel from "../../general-components/ErrorPanel";
import LoadingPanel from "../../general-components/LoadingPanel";
import InactiveProject from "./InvactiveProject";
import { useTranslation } from "react-i18next";
import { APP_STARTED } from "../applicationActions";
import { notBlank } from "../../common/general";

const Application = () => {
  const { t, i18n } = useTranslation();
  const error = useSelector(pipe(path(["application"]), getError));
  const project = useSelector(pipe(path(["application"]), getProject));

  const dispatch = useDispatch();

  useEffect(() => {
    console.log("Root Use Effect : language =>");
    console.log(i18n.language);
    if (notBlank(i18n.language)) {
      dispatch({
        type: APP_STARTED,
        language: i18n.language,
      });
      document.documentElement.lang = i18n.language;
      document.documentElement.dir = i18n.dir();
    }
  }, [dispatch, i18n, i18n.language]);

  return isEmpty(error) ? (
    isEmpty(project) ? (
      <LoadingPanel message={t("app_loading")} />
    ) : project.active ? (
      <SubmissionPanel />
    ) : (
      <InactiveProject />
    )
  ) : (
    <ErrorPanel error={error} />
  );
};

export default Application;
